import { useApiMutation } from '@locus-taxy/encore-ui-network';
import { useToast } from '@locus-taxy/encore-ui-toolkit';
import type { ApiError } from '@locus-taxy/encore-ui-network';
import type { DocumentInfo } from './useCurrentUser';

export interface UpdateUserRequest {
  actionId: string;
  variables: {
    preferences?: {
      timezone?: string;
      localeIdentifier?: string;
    };
    profileInformation?: {
      photo?: DocumentInfo | null;
    };
    [key: string]: unknown;
  };
}

export interface UpdateUserResponse {
  data: unknown;
  success: boolean;
}

export function useUpdateUser(
  clientId: string,
  entityName: string,
  instanceId: string | null,
  successMessage?: string
) {
  const { showApiError, showSuccess } = useToast();

  return useApiMutation<UpdateUserResponse, UpdateUserRequest>({
    endpointKey: 'workflow.action',
    params: { clientId, entityName, instanceId: instanceId || '' },
    config: {
      onSuccess: () => {
        showSuccess(successMessage || 'Profile updated successfully');
      },
      onError: (error: ApiError) => {
        showApiError(error);
      },
    },
  });
}
